import React from "react"
import styled from "styled-components"
import TextIcon from "material-ui/svg-icons/content/text-format"
import DividerIcon from "material-ui/svg-icons/content/remove"
import ImageIcon from "material-ui/svg-icons/image/photo"
import AvatarIcon from "material-ui/svg-icons/action/account-circle"
import ImageTextIcon from "material-ui/svg-icons/av/art-track"
import CarouselIcon from "material-ui/svg-icons/action/view-carousel"
import FlatButtonIcon from "material-ui/svg-icons/image/crop-7-5"
import ButtonIcon from "material-ui/svg-icons/content//add-circle-outline"
import FAButtonIcon from "material-ui/svg-icons/content//add"
import ProductListIcon from "material-ui/svg-icons/action/view-list"
import YoutubeIcon from "material-ui/svg-icons/notification/ondemand-video"

const colors = "#505659"

const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  width: 100%;
`

const DivContainer = styled.div`
  height: 100px;
  width: 100px;
  padding: 10px;
  background-color: #fff;
  display: flex;
  flex-direction: row;
  cursor: move;
  cursor: grab;
  cursor: -webkit-grab;
  border: 1px solid #ddd;
  border-radius: 4px;
  transition-duration: 0.15s;
  transition-property: box-shadow;
  &:hover {
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.35);
  }
`
export const Layout1 = () => (
  <DivContainer>
    <Content>
      <TextIcon style={styles.icon} color={colors} />
      <div style={{ color: colors }}>Text</div>
    </Content>
  </DivContainer>
)

export const Layout2 = () => (
  <DivContainer>
    <Content>
      <ImageIcon style={styles.icon} color={colors} />
      <div style={{ color: colors }}>Image</div>
    </Content>
  </DivContainer>
)

export const Layout3 = () => (
  <DivContainer>
    <Content>
      <ImageTextIcon style={styles.icon} color={colors} />
      <div style={{ color: colors }}>Image Text</div>
    </Content>
  </DivContainer>
)
export const Layout4 = () => (
  <DivContainer>
    <Content>
      <AvatarIcon style={styles.icon} color={colors} />
      <div style={{ color: colors }}>Avatar</div>
    </Content>
  </DivContainer>
)

export const Layout5 = () => (
  <DivContainer>
    <Content>
      <DividerIcon style={styles.icon} color={colors} />
      <div style={{ color: colors }}>Divider</div>
    </Content>
  </DivContainer>
)

export const Layout6 = () => (
  <DivContainer>
    <Content>
      <CarouselIcon style={styles.icon} color={colors} />
      <div style={{ color: colors }}>Carousel</div>
    </Content>
  </DivContainer>
)

export const Layout7 = () => (
  <DivContainer>
    <Content>
      <FlatButtonIcon style={styles.icon} color={colors} />
      <div style={{ color: colors }}>Flat & Raised Button</div>
    </Content>
  </DivContainer>
)
export const Layout8 = () => (
  <DivContainer>
    <Content>
      <ButtonIcon style={styles.icon} color={colors} />
      <div style={{ color: colors }}>Icon Button</div>
    </Content>
  </DivContainer>
)

export const Layout9 = () => (
  <DivContainer>
    <Content>
      <FAButtonIcon style={styles.icon} color={colors} />
      <div style={{ color: colors }}>FAB Button</div>
    </Content>
  </DivContainer>
)
export const Layout10 = () => (
  <DivContainer>
    <Content>
      <ProductListIcon style={styles.icon} color={colors} />
      <div style={{ color: colors }}>Product List</div>
    </Content>
  </DivContainer>
)
export const Layout11 = () => (
  <DivContainer>
    <Content>
      <YoutubeIcon style={styles.icon} color={colors} />
      <div style={{ color: colors }}>Youtube</div>
    </Content>
  </DivContainer>
)

export const Layout12 = () => (
  <DivContainer>
    <Content>
      <CarouselIcon style={styles.icon} color={colors} />
      <div style={{ color: colors }}>Carousel Animation</div>
    </Content>
  </DivContainer>
)

export const Layout13 = () => (
  <DivContainer>
    <Content>
      <ImageIcon style={styles.icon} color={colors} />
      <div style={{ color: colors }}>Deals Group</div>
    </Content>
  </DivContainer>
)

export const layoutsleft = {
  layout1: Layout1,
  layout2: Layout2,
  layout3: Layout3,
  layout4: Layout4,
  layout5: Layout5,
  layout6: Layout6,
  layout7: Layout7,
  layout8: Layout8,
  layout9: Layout9,
  layout10: Layout10,
  layout11: Layout11,
  layout12: Layout12,
  layout13: Layout13,
}

const styles = {
  icon: {
    width: 80,
    height: 80,
  },
}



// WEBPACK FOOTER //
// ./src/editor/layout/components/ContentBox.js